// Large resort parcels follow a landscaped Strip. Stable property ids retain
// player progress while each city's addresses have their own physical location.
export const vegasLandmarks = [
  {id:0,name:'Golden Crescent',area:'Las Vegas Boulevard',x:-17,z:-6,description:'Twin curved gold-glass resort towers with a palm-lined arrival court.'},
  {id:1,name:'Desert Wheel',area:'Resort promenade',x:16,z:-4,description:'An illuminated observation wheel above an outdoor dining promenade.'},
  {id:2,name:'Oasis Palace',area:'Fountain district',x:-17,z:21,description:'A grand lakeside resort with a choreographed fountain garden.'},
  {id:3,name:'Fremont Lights',area:'Downtown Las Vegas',x:-10,z:-44,description:'A glowing barrel-vault canopy above Downtown’s pedestrian street.'},
  {id:4,name:'Prism Sphere',area:'Entertainment district',x:23,z:-27,description:'A spherical performance venue wrapped in an animated light display.'},
] as const
export const vegasAddresses:Record<number,[number,number]> = {
  1:[-34,-46],3:[-34,-26],6:[-34,-6],8:[-34,4],9:[-34,24],11:[-34,46],
  13:[36,-46],14:[36,-26],16:[36,-6],18:[36,4],19:[36,24],21:[36,46],
  23:[-49,-44],24:[-49,-23],26:[-49,-2],27:[-49,20],29:[-49,42],
  31:[50,-44],33:[50,-23],34:[50,-2],36:[50,20],38:[50,42],
}
export function vegasPropertyPosition(id:number):[number,number]{
  if(id<100){const p=vegasLandmarks[id];return [p.x,p.z]}
  return vegasAddresses[id-100]??[0,0]
}
// Fixed spacing and equal speed prevent overtaking within each separate lane.
export function vegasLanePose(time:number,index:number,lane:number,length=102){
  const progress=((index/7+time*2.8/length)%1+1)%1,reverse=lane<0
  return {x:lane,z:(progress-.5)*length*(reverse?-1:1),angle:reverse?Math.PI:0,scale:Math.min(1,progress*30,(1-progress)*30)}
}
